export default __webpack_public_path__ + "static/media/search.32369a20.png";